import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  userData: null,
  loading: false,
  error: null,
};

export const userSlice = createSlice({
  name: 'user',
  initialState,
  reducers: {
    setUser: (state, action) => {
      state.userData = action.payload;
    },
    updateUser: (state, action) => {
      state.userData = { ...state.userData, ...action.payload };
    },
    clearUser: (state) => {
      state.userData = null;
    },
    setLoading: (state, action) => {
      state.loading = action.payload;
    },
    setError: (state, action) => {
      state.error = action.payload;
    },
  },
});

export const { setUser, updateUser, clearUser, setLoading, setError } = userSlice.actions;

export default userSlice.reducer;
